import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    search: {
        height: '32px',
        paddingLeft: '15px',
        paddingRight: '8px',
        fontSize: '16px',
        width: '250px',
        border: 0,
        borderRadius: 15,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        boxShadow: '0 1px 0 0 hsla(0,0%,100%,.15), inset 0 1px 0 0 rgba(0,0,0,.15)',
    },
    btn: {
        display: 'inline-block',
        padding: '5px 12px',
        fontSize: '14px',
        color: '#00a3f9',
        background: 'none',
        border: '1px solid #00a3f9',
        borderRadius: 12,
        marginLeft: 15,
        cursor: 'pointer',
        '&:hover': {
            borderColor: 'rgba(255,255,255,.15)',
            color: '#ffce01'
        },
        outline: 'none'
    }
}))

const columns = [
    { id: 'uuid', label: 'ID'},
    { id: 'name', label: 'Имя'},
    { id: 'provider', label: 'Провайдер'},
    { id: 'status', label: 'Режим'}
];

const getRows = (data) => {
    return data.map((item) => {
        const name = item.name[item.name.length - 1] === ' ' ? item.name.slice(0, item.name.length - 2) : item.name;
    
        return {
            uuid: item.uuid,
            name: name.split(/\s+/).map(word => word[0].toUpperCase() + word.substring(1)).join(' '),
            provider: item.provider,
            status: item.status 
        }
    })
} 

export {
    useStyles,
    columns,
    getRows
}